import { render, staticRenderFns } from "./orgPerson.vue?vue&type=template&id=6e41d29c&"
import script from "./orgPerson.vue?vue&type=script&lang=js&"
export * from "./orgPerson.vue?vue&type=script&lang=js&"
import style0 from "./orgPerson.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports